import { render, staticRenderFns } from "./requesterList.vue?vue&type=template&id=a8d4890a&scoped=true&"
import script from "./requesterList.vue?vue&type=script&lang=js&"
export * from "./requesterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d4890a",
  null
  
)

export default component.exports